import { useState } from "react";
import Modal from "react-modal";

import { Box, IconButton, Typography } from "@mui/material";
import ImageIcon from "@mui/icons-material/Image";
import ClearIcon from "@mui/icons-material/Clear";

import ModalContent from "../ModalContent";
import BloqueioIndicator from "./BloqueioIndicator";
import { ModalKitButton } from "./style";
import { TudoFarma } from "../TudoFarma";
import Product from "types/Product";

interface ProductNameProps {
  product: Product;
}

const ProductName = ({ product }: ProductNameProps) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalKitIsOpen, setModalKitIsOpen] = useState(false);
  const [modalBloqueioIsOpen, setModalBloqueioIsOpen] = useState(false);

  const openModal = () => setModalIsOpen(true);
  const openModalKit = () => setModalKitIsOpen(true);
  const openModalBloqueio = () => setModalBloqueioIsOpen(true);

  const closeModal = () => setModalIsOpen(false);
  const closeModalKit = () => setModalKitIsOpen(false);
  const closeModalBloqueio = () => setModalBloqueioIsOpen(false);

  const {
    id_tipo_mercadoria: idTipoMercadoria,
    infos: { pc_desconto_financeiro: pcDescontoFinanceiro },
  } = product;

  const hasFinancialDiscount = !(
    pcDescontoFinanceiro === 0 ||
    pcDescontoFinanceiro === "undefined" ||
    idTipoMercadoria.toString() !== "2"
  );

  return (
    <>
      {modalIsOpen && product.url_imagem && (
        <Modal
          isOpen={modalIsOpen}
          className="modal"
          onRequestClose={closeModal}
          contentLabel="Imagem do Produto"
          style={{ overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" } }}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
        >
          <div className="head">
            <h2>{product.ds_apresentacao}</h2>
            <IconButton onClick={closeModal} type="button">
              <ClearIcon />
            </IconButton>
          </div>
          <div className="content">
            <img
              src={
                typeof product.url_imagem === "string" ? product.url_imagem : ""
              }
              alt={product.ds_apresentacao}
            />
            <p>
              <em>(Imagens meramente ilustrativas)</em>
            </p>
          </div>
        </Modal>
      )}
      {modalKitIsOpen && (
        <Modal
          isOpen={modalKitIsOpen}
          className="modal"
          onRequestClose={closeModalKit}
          contentLabel="Detalhes do Kit"
          style={{ overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" } }}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
        >
          <div className="head">
            <h2>{product.ds_apresentacao}</h2>
            <IconButton onClick={closeModalKit} type="button">
              <ClearIcon />
            </IconButton>
          </div>
          <ModalContent product={product} />
        </Modal>
      )}

      <Box display="flex" alignItems="start" flexDirection="row">
        <Box margin="auto">
          <IconButton
            onClick={openModal}
            disabled={!product.url_imagem}
            type="button"
          >
            <ImageIcon />
          </IconButton>
        </Box>
        <Box flex="1">
          {idTipoMercadoria.toString() === "-1" ? (
            <ModalKitButton type="button" onClick={openModalKit}>
              {product.ds_apresentacao}
            </ModalKitButton>
          ) : (
            <span>
              {product.ds_apresentacao}
              {product.bloqueio ? (
                <BloqueioIndicator
                  product={product}
                  modalBloqueioIsOpen={modalBloqueioIsOpen}
                  closeModalBloqueio={closeModalBloqueio}
                  openModalBloqueio={openModalBloqueio}
                />
              ) : null}
            </span>
          )}
          {product.infos.id_falta === "S" && (
            <>
              <em className="out-of-stock"> (Em falta)</em>
            </>
          )}

          <br />
          <Typography component="span" variant="caption">
            {product.ean_venda_mercadoria}: {product.ds_mercadoria}
          </Typography>

          {hasFinancialDiscount && (
            <>
              <br />
              <em className="financial-discount">
                (Após a finalização do pedido você receberá{" "}
                {product.infos.pc_desconto_financeiro}% de desconto no boleto)
              </em>
            </>
          )}
        </Box>
        <TudoFarma product={product} />
      </Box>
    </>
  );
};

export default ProductName;
